// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_naS","cls2":"FeedbackPopover-cls2_Zx2 FeedbackPopover-cls1_naS"};